import React, { useState } from "react";
import { GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { auth } from "../../firebase/config";
import { useNavigate } from "react-router-dom";

const AdminLogin = () => {
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      
      // Get the ID token to access custom claims
      const idTokenResult = await user.getIdTokenResult();
      
      if (idTokenResult.claims.role === 'admin') {
        navigate("/admin/dashboard");
      } else {
        setError("⛔ Access denied. You are not an admin.");
        await signOut(auth);
      }
    } catch (err) {
      setError("Login failed. Try again.");
      console.error(err.message);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-green-50">
      <div className="bg-white p-8 rounded-xl shadow-lg max-w-sm w-full text-center">
        <h2 className="text-2xl font-bold text-green-700 mb-4">Admin Login</h2>
        <p className="text-gray-600 mb-6">Sign in to access JR‑Home Made Foods Admin Panel</p>
        {error && <p className="text-red-600 mb-4">{error}</p>}
        <button
          onClick={handleLogin}
          className="bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-all w-full font-semibold"
        >
          Sign in with Google
        </button>
        
        <div className="mt-6 text-center">
          <p className="text-sm text-gray-600 mb-2">Are you a delivery partner?</p>
          <button
            onClick={() => navigate('/delivery-partner/login')}
            className="text-green-600 hover:text-green-700 text-sm font-medium"
          >
            0 Delivery Partner Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin; 